import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, isRef as _isRef, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "set-distribution-box"
};
const _hoisted_2 = {
  class: "distribution-platform"
};
const _hoisted_3 = {
  class: "distribution-platform-ul"
};
const _hoisted_4 = {
  class: "li-action"
};
const _hoisted_5 = {
  class: "distribution-setting"
};
const _hoisted_6 = {
  class: "auto-wrap-content"
};
import { ref, computed, onMounted, reactive } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessageBox, ElMessage } from 'element-plus';
import 'element-plus/es/components/message-box/style/index'
import 'element-plus/es/components/message/style/index'

import { getMediaType, checkMedia, uploadVideo, release, checkCookie } from '@/request/mediaPlatform';

// 获取路由实例

export default {
  __name: 'setDistribution',
  props: {
    videoMultiple: {
      type: Boolean,
      default: false
    },
    publishDrawer: {
      type: Boolean,
      default: false
    },
    publishIdModel: {
      type: String,
      default: ''
    },
    publishTitleModel: {
      type: String,
      default: ''
    },
    contentModel: {
      type: String,
      default: ''
    },
    publishTagsModel: {
      type: Array,
      default: () => []
    },
    portfolioArr: {
      type: Array,
      default: () => []
    },
    bindMediaArr: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:publishDrawer', 'update:publishIdModel', 'update:contentModel'],
  setup(__props, {
    emit: __emit
  }) {
    const router = useRouter();
    const emits = __emit;
    const props = __props;
    const publishFormRef = ref(null);
    const publishLoading = ref(false);
    const releaseVerify = ref(false);
    const mediaDic = {
      douyin: 'tiktok'
    };
    const mediaData = ref([]);
    const getMediaTypeFn = () => {
      getMediaType().then(({
        data
      }) => {
        if (data.code !== 200) return;
        mediaData.value = data.data;
      });
    };
    const options = [{
      value: '万川AI新媒体平台',
      label: '万川AI新媒体平台'
    }, {
      value: '门窗',
      label: '门窗'
    }, {
      value: '佛山市',
      label: '佛山市'
    }];
    const accreditForm = ref({
      sms: ''
    });

    // 创建一个带有自定义 getter 和 setter 的计算属性
    const smsComputed = computed({
      get: () => accreditForm.value.sms,
      // 获取器直接返回当前值
      set: val => {
        // 设置器用于确保只有数字被输入，并且可以以0开头
        const numericOnly = val.replace(/[^0-9]/g, ''); // 移除非数字字符
        accreditForm.value.sms = numericOnly;
      }
    });
    let publishDrawerModel = computed({
      get() {
        return props.publishDrawer;
      },
      set(value) {
        emits('update:publishDrawer', value);
      }
    });
    const publishForm = ref({
      title: computed({
        get() {
          return props.publishTitleModel;
        },
        set(value) {
          emits('update:publishTitleModel', value);
        }
      }),
      tags: computed({
        get() {
          return props.publishTagsModel;
        },
        set(value) {
          emits('update:publishTagsModel', value);
        }
      }),
      account: '',
      publishIdModel: computed({
        get() {
          return props.publishIdModel;
        },
        set(value) {
          emits('update:publishIdModel', value);
        }
      }),
      content: computed({
        get() {
          return props.contentModel;
        },
        set(value) {
          emits('update:contentModel', value);
        }
      })
    });
    const rules = reactive({
      publishIdModel: [{
        required: true,
        message: '请至少选择一项视频项',
        trigger: 'change'
      }],
      tags: [{
        required: true,
        message: '请至少选择一项视频类型',
        trigger: 'change'
      }],
      title: [{
        required: true,
        message: '请输入标题（0-30字）',
        min: 1,
        max: 30,
        trigger: ['blur', 'change']
      }],
      content: [{
        required: true,
        message: '请输入视频内容简介',
        trigger: ['blur', 'change']
      }]
    });
    const publishSetFn = () => {
      ElMessageBox.confirm('将会为您跳转个人中心，编辑内容不会保存是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => router.push('/user-center'));
    };
    const handleSubmit = () => {
      if (!accreditForm.value.sms) return;
    };
    async function checkCookiesAndRecordFailures(mediaIds) {
      const checkPromises = mediaIds.map(account => checkCookie({
        account
      }).then(res => ({
        account,
        code: res.data.code
      })).catch(error => ({
        account,
        error
      })));
      const results = await Promise.allSettled(checkPromises);
      const failedAccounts = results.filter(result => result.status === 'fulfilled' && result.value.code === 500).map(result => result.value.account);
      if (failedAccounts.length > 0) {
        // 如果有账号返回了500错误码，则返回这些账号
        return failedAccounts;
      } else {
        // 如果没有账号返回500错误码，则返回true
        return false;
      }
    }
    async function onSubmit(formEl) {
      if (!formEl) return;
      try {
        publishLoading.value = true;

        // Validate the form first
        const isValid = await formEl.validate();
        if (!isValid) {
          console.log('error submit!');
          publishLoading.value = false; // 添加：验证失败时重置加载状态
          return;
        }
        const result = await checkCookiesAndRecordFailures(props.bindMediaArr);
        if (result) {
          ElMessage.warning(result.map(account => `${account}账号过期请重新授权绑定`).join('，'));
          publishDrawerBtn.value = false; // 添加：媒体检查失败时重置加载状态
          return;
        }

        // Prepare submission object
        const portfolioItem = props.portfolioArr.find(v => v.id === publishForm.value.publishIdModel);
        console.log('portfolioItem', portfolioItem);
        const file = portfolioItem.videoMakeMediaUrl;
        const subObj = {
          accounts: props.bindMediaArr.join(','),
          title: publishForm.value.title,
          tags: (publishForm.value.tags || []).map(tag => `#${tag}`).join(' '),
          file,
          content: publishForm.value.content,
          platformType: 'douyin'
        };

        // 获取流程id
        const releaseResponse = await release(subObj);
        // 发布视频
        const response = await uploadVideo({
          ...subObj,
          batchId: releaseResponse.data.data
        });
        if (response.data.code === 200) {
          ElMessage.success('发布成功');
          publishLoading.value = false;
          // 延迟执行 publishDrawerModel
          setTimeout(() => {
            publishDrawerModel.value = false;
          }, 2000);
        }
      } catch (error) {
        // Handle any errors that occur during the asynchronous operations
        console.error('An error occurred:', error);
        publishLoading.value = false; // 添加：在捕获到异常时重置加载状态
      }
    }
    onMounted(() => {
      getMediaTypeFn();
      console.log('asd', publishForm.value);
    });
    return (_ctx, _cache) => {
      const _component_svgIcon = _resolveComponent("svgIcon");
      const _component_Setting = _resolveComponent("Setting");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[8] || (_cache[8] = _createElementVNode("div", {
        class: "label"
      }, "平台", -1)), _createElementVNode("ul", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mediaData.value, i => {
        return _openBlock(), _createElementBlock("li", _hoisted_4, [_createVNode(_component_svgIcon, {
          iconClass: mediaDic[i.value],
          width: "2vw",
          height: "2vw"
        }, null, 8, ["iconClass"])]);
      }), 256))])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_tabs, {
        class: "distribution-setting-tabs",
        type: "border-card",
        editable: ""
      }, {
        "add-icon": _withCtx(() => [_createVNode(_component_el_icon, {
          style: {
            "display": "block"
          },
          onClick: publishSetFn
        }, {
          default: _withCtx(() => [_createVNode(_component_Setting)]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
          label: "发布设置"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_form, {
            ref_key: "publishFormRef",
            ref: publishFormRef,
            model: publishForm.value,
            rules: rules,
            "status-icon": "",
            "label-width": "auto"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "发布视频项：",
              prop: "publishIdModel"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: publishForm.value.publishIdModel,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => publishForm.value.publishIdModel = $event),
                placeholder: "请选择所需的视频项",
                clearable: "",
                multiple: __props.videoMultiple
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.portfolioArr, i => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    label: i.name,
                    value: i.id
                  }, null, 8, ["label", "value"]);
                }), 256))]),
                _: 1
              }, 8, ["modelValue", "multiple"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "标题：",
              prop: "title"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: publishForm.value.title,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => publishForm.value.title = $event),
                placeholder: "平台独立标题（0-30字）"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "视频类型：",
              prop: "tags"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: publishForm.value.tags,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => publishForm.value.tags = $event),
                multiple: "",
                filterable: "",
                "allow-create": "",
                "default-first-option": "",
                "reserve-keyword": false,
                placeholder: "视频类型"
              }, {
                default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, item => {
                  return _createVNode(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]);
                }), 64))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "视频内容简介：",
              prop: "content"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                type: "textarea",
                modelValue: publishForm.value.content,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => publishForm.value.content = $event),
                rows: 30,
                placeholder: "可输入视频内容"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[4] || (_cache[4] = $event => onSubmit(publishFormRef.value))
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode(" 发布 ")])),
                _: 1
              }), _createVNode(_component_el_button, {
                onClick: _cache[5] || (_cache[5] = $event => _isRef(publishDrawerModel) ? publishDrawerModel.value = false : publishDrawerModel = false)
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode("取消")])),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }, 8, ["model", "rules"])])]),
          _: 1
        })]),
        _: 1
      })])])), [[_directive_loading, publishLoading.value]]), _createVNode(_component_el_dialog, {
        modelValue: releaseVerify.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => releaseVerify.value = $event),
        width: "500",
        title: "发布验证"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          "label-position": "left",
          size: "medium"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "验证码"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: smsComputed.value,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => smsComputed.value = $event),
              placeholder: "请输入验证码"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              onClick: handleSubmit
            }, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [_createTextVNode("授权登录")])),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])], 64);
    };
  }
};